import { ButtonVariant, Div, LoaderButton, Typography, TypographyVariant } from '@up2rent/ui-new';

interface WorkspaceSwitchOption {
  id: string;
  name: string;
}

interface WorkspaceSwitchListProps {
  title: string;
  workspaces: WorkspaceSwitchOption[];
  switchLabel: string;
  switchingId: string | null;
  disabled?: boolean;
  onSwitch: (workspaceId: string) => void;
}

const WorkspaceSwitchList = ({
  title,
  workspaces,
  switchLabel,
  switchingId,
  disabled = false,
  onSwitch,
}: WorkspaceSwitchListProps) => (
  <Div column className="gap-2">
    <Typography variant={TypographyVariant.MUTED} size="xs" bold>
      {title}
    </Typography>
    {workspaces.map((workspace) => (
      <Div
        key={workspace.id}
        row
        className="items-center justify-between gap-4 rounded-lg border border-border px-3 py-2"
      >
        <Typography className="truncate">{workspace.name}</Typography>
        <LoaderButton
          variant={ButtonVariant.OUTLINE}
          size="sm"
          loading={switchingId === workspace.id}
          disabled={disabled}
          onClick={() => onSwitch(workspace.id)}
        >
          {switchLabel}
        </LoaderButton>
      </Div>
    ))}
  </Div>
);

export default WorkspaceSwitchList;
